var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsolationMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 670,
    height: 514,
    viewBox: "0 0 670 514",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_899_354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.59 0.750113C308.95 -5.19989 394.19 95.0401 513.45 106.3C568.96 111.54 649.74 90.0701 666.19 164.66C692.35 283.29 539.08 447.54 437.34 490.94C247.08 572.1 44.61 418.19 5.51003 231.64C-20.28 108.58 55.69 6.64011 181.59 0.750113Z",
    fill: "#FAF7F2",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_899_354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 669.65,
    height: 513.63,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsolationMode);
export default __webpack_public_path__ + "static/media/Isolation_Mode.6f1ff904d9fe69add8a0c02d92e41a51.svg";
export { ForwardRef as ReactComponent };